import React from 'react';

const AdminPopup = ({
  open,
  closePopup = () => {},
  title,
  subTitle,
  children,
  footer,
  customHeightClasses,
  customWidthClasses,
  backButton,
}) => {
  if (!open) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-white/10 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="absolute top-0 left-0 w-full h-full z-10" onClick={closePopup} />
      <div
        className={`bg-white shadow-md rounded-lg flex flex-col w-full ${customWidthClasses || 'max-w-2xl'} ${customHeightClasses || 'h-[80vh] max-h-[900px]'} relative z-20 overflow-hidden`}>
        {/* Header */}
        {title && (
          <div className="bg-lightBlue-10 text-blue-10 px-4 py-2 flex justify-between items-center">
            <div className="flex items-center">
              {backButton && backButton.show && (
                <button
                  onClick={backButton.onClick}
                  className="mr-4 bg-blue-10 text-white w-6 h-6 flex items-center justify-center rounded-lg shadow-sm hover:bg-blue-20 hover:scale-105 active:scale-95 transition-all duration-300">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
              )}
              <div className="flex flex-col">
                <h2 className="font-semibold">{title}</h2>
                {subTitle && <h2 className="text-sm">{subTitle}</h2>}
              </div>
            </div>
            <button
              onClick={closePopup}
              className="bg-blue-10 text-white w-6 h-6 flex items-center justify-center rounded-lg shadow-sm hover:bg-blue-20 hover:scale-105 active:scale-95 transition-all duration-300">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        )}

        {/* Content - Scrollable */}
        <div className="flex-grow overflow-y-auto p-4">{children}</div>

        {/* Footer - Fixed at the bottom */}
        {footer && <div className="border-t border-gray-200 p-4 bg-white">{footer}</div>}
      </div>
    </div>
  );
};

export default AdminPopup;
